import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import Sidebar from "components/Sidebar";
import PanelsLayout from "components/PanelsLayout";
import { useContext, useEffect, useState } from "react";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";
import SyncStatusPopup from "components/SyncStatusPopup";
import { useMediaQuery } from "usehooks-ts";
import { Drawer } from "@mui/material";
import ModalsManagerContext from "contexts/ModalsManager";
import SidebarAddingOptions from "components/SidebarAddingOptions";

const ApplicationLayout: FC<Props> = ({ children }) => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width: 767px)");
  const [isScroll, setIsScroll] = useState(false);
  const auth = useAuth();
  const isGuest = auth?.user?.profile?.role === "guest";

  const { modals, setModals } = useContext(ModalsManagerContext);

  const [isExpanded, setIsExpanded] = useState(true);

  const notExpandedSize = (72 / window.innerWidth) * 100;

  const handleExpand = () => {
    localStorage.setItem("menu_expand", String(!isExpanded));
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    const value = localStorage.getItem("menu_expand");
    if (value !== "undefined") {
      setIsExpanded(value === "true" ? true : false);
    }
  }, []);

  useEffect(() => {
    if (
      auth.isAuthenticated &&
      isGuest &&
      window.location.pathname.search("activation") === -1
    ) {
      navigate("/packages/1B8AE8D3-3209-497D-9526-27608FFFA84D/incoming");
    }
  }, [isGuest]);

  const isFullScreen = window.location.href.search("fullscreen") !== -1;
  if (isFullScreen) {
    return children;
  }

  const leftPanel = () => {
    return (
      <div className={styles.menuWrapper}>
        <Sidebar
          isExpanded={isExpanded || isMobile}
          handleExpand={handleExpand}
          setIsScroll={setIsScroll}
        />
      </div>
    );
  };

  const rightPanel = () => {
    return (
      <div className={styles.applicationWrapper}>
        {children}
        <SyncStatusPopup></SyncStatusPopup>
      </div>
    );
  };

  return (
    <div className={styles.application}>
      {!isMobile && (
        <PanelsLayout
          isExpanded={isExpanded}
          leftPanel={leftPanel()}
          rightPanel={rightPanel()}
          layoutName="main"
          leftClassName={styles.left}
          defaultLeft={isExpanded ? 20 : notExpandedSize}
          disableHeader={isFullScreen ? false : true}
          disableIcons
          disablePaddingScroll={isScroll}
        />
      )}

      {isMobile && (
        <Drawer
          open={modals.menu}
          onClose={() => setModals({ ...modals, menu: false })}
          sx={{
            ".MuiDrawer-paper": {
              overflowX: "hidden",
            },
          }}
        >
          {leftPanel()}
        </Drawer>
      )}

      {isMobile && rightPanel()}

      {isMobile && (
        <Drawer
          anchor={"bottom"}
          open={modals.createMobile}
          onClose={() => setModals((old) => ({ ...old, createMobile: false }))}
        >
          <SidebarAddingOptions
            addButtonRef={undefined}
            portal={false}
            toggle={() => setModals((old) => ({ ...old, createMobile: false }))}
          ></SidebarAddingOptions>
        </Drawer>
      )}
    </div>
  );
};

export default ApplicationLayout;
